import { Checkbox, Input } from 'antd'
import React, { useState } from 'react'

const SubTaskManager = ({
  subTitle,
  subTasks = [],
  onSubTasksChange,
  onToggleCheck,
  disabled = false,
}) => {
  const [tempSubTask, setTempSubTask] = useState('')
  const [editingId, setEditingId] = useState(null)

  const handleInputSubmit = () => {
    if (!tempSubTask.trim()) {
      return
    }
    const newSubTask = {
      id: `new-${Date.now()}`,
      title: tempSubTask.trim(),
      isDone: false,
    }
    onSubTasksChange([...subTasks, newSubTask])
    setTempSubTask('')
  }

  const removeSubTask = (targetId) => {
    onSubTasksChange(subTasks.filter((item) => item.id !== targetId))
  }

  const toggleCheckItem = (id) => {
    // 새로 생성된 항목(아직 저장되지 않은 항목)은 체크 불가
    const targetItem = subTasks.find((item) => item.id === id)
    if (
      targetItem &&
      typeof targetItem.id === 'string' &&
      targetItem.id.startsWith('new-')
    ) {
      return // 새로 생성된 항목은 체크 불가
    }

    // API 호출이 있으면 API 호출, 없으면 로컬 상태만 업데이트
    if (onToggleCheck) {
      onToggleCheck(id)
    } else {
      onSubTasksChange(
        subTasks.map((item) =>
          item.id === id ? { ...item, isDone: !(item.isDone ?? false) } : item,
        ),
      )
    }
  }

  const handleTitleChange = (id, newTitle) => {
    onSubTasksChange(
      subTasks.map((item) =>
        item.id === id ? { ...item, title: newTitle } : item,
      ),
    )
  }

  return (
    <div
      style={{
        border: '1px solid #E2EAEF',
        borderRadius: '12px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* 헤더 */}
      <div
        style={{
          background: '#F6F7FA',
          padding: '12px 16px',
          borderBottom: '1px solid #E2EAEF',
        }}
      >
        <div
          style={{
            fontSize: '15px',
            fontWeight: '700',
            color: '#383E44',
          }}
        >
          하위업무 생성하기
        </div>
        <div
          style={{
            fontSize: '12px',
            color: '#8A949E',
            marginTop: '2px',
          }}
        >
          {subTitle}
        </div>
      </div>

      {/* 그리드 영역 */}
      <div
        style={{
          background: '#FFFFFF',
          padding: '16px',
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            columnGap: '40px',
            rowGap: '12px',
            width: '100%',
            paddingRight: '15px',
          }}
        >
          {/* 저장된 항목 리스트 */}
          {subTasks.map((item) => (
            <div
              key={item.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                width: '100%',
                minWidth: 0,
              }}
            >
              <div
                style={{
                  flex: 1,
                  display: 'flex',
                  alignItems: 'center',
                  padding: '0 12px',
                  background: '#FFFFFF',
                  borderRadius: '8px',
                  border: `1px solid ${(item.isDone ?? false) ? '#E2EAEF' : '#383E44'}`,
                  height: '44px',
                  minWidth: 0,
                }}
              >
                <Checkbox
                  checked={!!(item.isDone ?? false)}
                  onChange={() => toggleCheckItem(item.id)}
                  className="custom-circle-checkbox"
                  style={{ marginRight: '10px' }}
                  disabled={
                    disabled ||
                    (typeof item.id === 'string' && item.id.startsWith('new-'))
                  }
                />
                {editingId === item.id ? (
                  <Input
                    value={item.title}
                    variant="borderless"
                    autoFocus
                    onBlur={() => setEditingId(null)}
                    onPressEnter={() => setEditingId(null)}
                    onChange={(e) => handleTitleChange(item.id, e.target.value)}
                    disabled={disabled}
                    style={{
                      padding: 0,
                      fontSize: 'inherit',
                      fontWeight: 'inherit',
                      color: 'inherit',
                    }}
                  />
                ) : (
                  <div
                    onClick={() => !disabled && setEditingId(item.id)}
                    style={{
                      flex: 1,
                      fontSize: '14px',
                      fontWeight: '600',
                      color: (item.isDone ?? false) ? '#007AFF' : '#191a1c',
                      textDecoration:
                        (item.isDone ?? false) ? 'line-through' : 'none',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      cursor: disabled ? 'default' : 'pointer',
                    }}
                  >
                    {item.title}
                  </div>
                )}
              </div>
              <div
                onClick={() => !disabled && removeSubTask(item.id)}
                style={{
                  flexShrink: 0,
                  width: '24px',
                  height: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: '#E2EAEF',
                  borderRadius: '50%',
                  cursor: disabled ? 'not-allowed' : 'pointer',
                  opacity: disabled ? 0.5 : 1,
                }}
              >
                <span
                  style={{
                    color: '#8A949E',
                    fontSize: '14px',
                    fontWeight: 'bold',
                  }}
                >
                  ×
                </span>
              </div>
            </div>
          ))}

          {/* 현재 입력 중인 세트 */}
          {!disabled && (
            <div
              style={{
                display: 'flex',
                gap: '8px',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  flex: 1,
                  display: 'flex',
                  alignItems: 'center',
                  padding: '0 12px',
                  background: '#FFFFFF',
                  borderRadius: '8px',
                  border: '1px solid #E2EAEF',
                  height: '44px',
                }}
              >
                <Input
                  placeholder="하위업무를 적어주세요"
                  value={tempSubTask}
                  variant="borderless"
                  style={{ flex: 1, padding: 0, minWidth: 0 }}
                  onChange={(e) => setTempSubTask(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      // e.nativeEvent.isComposing이 true이면 한글 조합 중이므로 실행하지 않음
                      if (e.nativeEvent.isComposing) return

                      handleInputSubmit()
                    }
                  }}
                />
              </div>
              <button
                onClick={handleInputSubmit}
                disabled={!tempSubTask.trim()}
                style={{
                  width: '52px',
                  height: '44px',
                  background: '#FFFFFF',
                  border: `1px solid ${tempSubTask.trim() ? '#007AFF' : '#D1D5DB'}`,
                  color: tempSubTask.trim() ? '#007AFF' : '#D1D5DB',
                  borderRadius: '8px',
                  cursor: tempSubTask.trim() ? 'pointer' : 'not-allowed',
                  fontWeight: '600',
                }}
              >
                입력
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default SubTaskManager
